import InputWithStepperField, { InputWithStepperFieldProps } from './InputWithStepperField';

export type { InputWithStepperFieldProps };
export default InputWithStepperField;
